import { TrafficCone } from '@carbon/icons-react';
import { Content, Section, Heading, Tile, Grid, Column } from '@carbon/react';
import { redirect } from 'react-router';
import { getUserId } from '#app/utils/auth.server.ts';
import { userHasRole } from '#app/utils/permissions.server.ts';
import { getSystemName } from '#app/utils/system-name.server.ts';
import { type Route } from './+types/under-construction.ts';

export async function loader({
  request,
}: Route.LoaderArgs): Promise<{ systemName: string }> {
  const systemName = await getSystemName();

  // Check if user is logged in and has admin role
  const userId = await getUserId(request);
  if (userId) {
    const isAdmin = await userHasRole(userId, 'admin');
    if (isAdmin) {
      throw redirect('/');
    }
  }

  return { systemName };
}

export default function UnderConstruction({
  loaderData,
}: Route.ComponentProps) {
  const { systemName } = loaderData;

  return (
    <>
      <title>{`Under Construction - ${systemName}`}</title>
      <meta name="robots" content="noindex, nofollow" />
      <Content className="mt-0! min-h-screen bg-gray-50 dark:bg-gray-900">
        <Grid>
          <Column sm={4} md={8} lg={16}>
            <Section className="flex justify-center mt-52">
              <div className="mx-auto w-full max-w-md">
                <Tile className="p-8!">
                  <div className="flex flex-col gap-3 text-center mb-6">
                    <div className="flex justify-center">
                      <TrafficCone
                        size={64}
                        className="text-orange-400 dark:text-orange-500"
                      />
                    </div>

                    <div className="flex items-center justify-center gap-2 mb-2">
                      <span className="text-2xl font-bold text-gray-900 dark:text-white">
                        {systemName}
                      </span>
                    </div>

                    <Heading className="text-gray-700 dark:text-gray-300">
                      Under Construction
                    </Heading>

                    <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto">
                      We're currently performing maintenance on our system.
                      Please check back later. We apologize for any
                      inconvenience.
                    </p>

                    <div className="pt-6 space-y-4">
                      <div className="inline-flex items-center space-x-2 text-lg text-gray-700 dark:text-gray-300">
                        <div className="w-4 h-4 bg-orange-400 dark:bg-orange-500 rounded-full animate-pulse"></div>
                        <span>System maintenance in progress</span>
                      </div>
                    </div>
                  </div>
                </Tile>
              </div>
            </Section>
          </Column>
        </Grid>
      </Content>
    </>
  );
}
